
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningSleetShowersNightColour as ObiLightningSleetShowersNightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-sleet-showers-night-colour.js';
 
 
 

 
 export const ObiLightningSleetShowersNightColour = createComponent({
   react: React,
   tagName: 'obi-lightning-sleet-showers-night-colour',
   elementClass: ObiLightningSleetShowersNightColourElement,
   events: {
     
   }
  });
 
 